import React from "react"

import { IonSelectOption } from "@ionic/react"

import { divider } from "./IonSelectDivider.scss"

export const IonSelectDivider: React.FC = () => {
	return <IonSelectOption className={divider} disabled />
}
